import React from 'react';
import { Marker, useNavermaps } from 'react-naver-maps';
import { getMarkerStyle } from '../utils/mapUtils';

function SoilTypeMarker({ borehole, selected }) {
  const { fillColor, borderColor } = getMarkerStyle(borehole.soil_type, borehole.is_temp_soil_type);
  const navermaps = useNavermaps();

  // 선택된 경우 파란 점선 테두리 적용
  const markerIcon = {
    content: `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
        <circle cx="12" cy="12" r="10" fill="${fillColor}" stroke="${selected ? '#0000ff' : borderColor}" stroke-width="2" ${selected ? 'stroke-dasharray="4,2"' : ''} />
      </svg>`,
    size: new navermaps.Size(24, 24),
    anchor: new navermaps.Point(12, 12),
  };

  return (
    <Marker
      key={borehole.id}
      position={new navermaps.LatLng(borehole.grs80_x, borehole.grs80_y)}
      icon={markerIcon}
    />
  );
}

export default SoilTypeMarker;